import { useState } from 'react';
import { TableInput } from '../../../../../components/common';
import CustomSelect from '../../../../../components/common/SelectField';
import { Checkbox, MenuItem } from '@mui/material';
import ObservationInput from './ObservationInput';
interface IProps {
  moduleData: any;
  isView: boolean;
}
const TbodySetup = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <tbody>
      {moduleData.specs &&
        moduleData.specs.map((spec: any, index: number) => (
          <tr key={index + 'specs'}>
            <td style={{ width: '80px' }}>{index + 1}</td>
            <td style={{ minWidth: '200px' }}>{spec.parameter}</td>
            <td style={{ minWidth: '200px' }}>{spec.specification}</td>
            <td style={{ minWidth: '200px' }}>{spec.methods}</td>
            {Array.from({ length: 12 }, (_, obsIndex) => (
              <td
                key={obsIndex + 'obs'}
                style={{ textTransform: 'uppercase', minWidth: '90px' }}
              >
                <ObservationInput
                  {...{ spec, setRender, isView, obsIndex }}
                  obsNumber={0}
                  checkType={spec.appearance}
                />
              </td>
            ))}
            <td style={{ textTransform: 'uppercase', width: '120px' }}>
              {!isView && spec.appearance === 'check3' ? (
                <CustomSelect
                  name="dropdown"
                  value={spec.result || ''}
                  onChange={(e) => {
                    spec.result = e.target.value;
                    setRender((prev) => !prev);
                  }}
                  sx={{
                    textAlign: 'center',
                  }}
                >
                  <MenuItem value="">NONE</MenuItem>
                  <MenuItem value="ok">O</MenuItem>
                  <MenuItem value="ng">X</MenuItem>
                </CustomSelect>
              ) : (
                (spec.result === 'ok' && 'O') || (spec.result === 'ng' && 'X')
              )}
            </td>
            <td>
              <TableInput
                name="action_taken"
                type="text"
                value={spec?.action_taken}
                onChange={(e) => {
                  spec.action_taken = e.target.value;
                  setRender((prev) => !prev);
                }}
                isView={isView}
              />
            </td>
            <th>{moduleData.report_prepared_by}</th>
            <td
              colSpan={isView ? 2 : 1}
              style={{
                textTransform: 'uppercase',
                // width: '13%',
                minWidth: '150px',
              }}
            >
              <TableInput
                isView={isView}
                name="remarks"
                type="text"
                value={spec.remarks}
                onChange={(e) => {
                  spec.remarks = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            {!isView && (
              <td style={{ minWidth: '150px' }}>
                <Checkbox
                  name="changeCheckbox"
                  checked={spec.appearance === 'check3'}
                  onChange={() => {
                    if (spec.prev_appearance) {
                      spec.appearance = spec.prev_appearance;
                      spec.prev_appearance = null;
                    } else {
                      spec.prev_appearance = spec.appearance;
                      spec.appearance = 'check3';
                    }
                    setRender((prev) => !prev);
                  }}
                  style={{ color: '#064a29' }}
                />
              </td>
            )}
          </tr>
        ))}
    </tbody>
  );
};

export default TbodySetup;
